import { ProductFragment, ProductType } from '$/GraphQL/schema/types';

import { AccessControl } from './Info/AccessControl';
import { AdditionalRegistrants } from './Info/AdditionalRegistrants';
import { AddOn } from './Info/AddOn';
import { CustomDomains } from './Info/CustomDomains';
import { Marketo } from './Info/Marketo';
import { RemoveBranding } from './Info/RemoveBranding';
import { Salesforce } from './Info/Salesforce';
import { UniversalDashboard } from './Info/UniversalDashboard';
import { WebinarSeries } from './Info/WebinarSeries';

export const getAddOn = (product: ProductFragment): AddOn => {
  switch (product.type) {
    case ProductType.AccessControl:
      return new AccessControl(product);
    case ProductType.Domains:
      return new CustomDomains(product);
    case ProductType.Salesforce:
      return new Salesforce(product);
    case ProductType.Marketo:
      return new Marketo(product);
    case ProductType.AdditionalRegistrants:
      return new AdditionalRegistrants(product);
    case ProductType.RemoveBranding:
      return new RemoveBranding(product);
    case ProductType.UniversalDashboard:
      return new UniversalDashboard(product);
    case ProductType.WebinarSeries:
      return new WebinarSeries(product);
    default:
      return new AddOn(product);
  }
};
